import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-volumeX",
  "use": "icon-volumeX-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-volume-x\" id=\"icon-volumeX\"><polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\" /><line x1=\"23\" y1=\"9\" x2=\"17\" y2=\"15\" /><line x1=\"17\" y1=\"9\" x2=\"23\" y2=\"15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/volumeX.svg
// module id = af3k
// module chunks = 73